import { useState, useEffect } from "react";
import { API_ENDPOINTS } from "../../../api/endpoints";
import Cookies from "js-cookie";

const TarifasFormModal = ({ visible, onClose, onSuccess, tarifaParaEditar }) => {
  const [tipo_movil, setTipoMovil] = useState("");
  const [capability_value, setCapabilityValue] = useState("");
  const [tag_rate, setTagRate] = useState("");
  const [min_rate, setMinRate] = useState("");
  const [km_rate, setKmRate] = useState("");
  const [bandera, setBandera] = useState("");
  const [estado, setEstado] = useState(1);

  const [cargando, setCargando] = useState(false);
  const [error, setError] = useState(null);
  const [exito, setExito] = useState(false);
  const [mostrarConfirmacion, setMostrarConfirmacion] = useState(false);
  const [eliminando, setEliminando] = useState(false);
  const [eliminadoOk, setEliminadoOk] = useState(false);

  useEffect(() => {
    if (tarifaParaEditar) {
      setTipoMovil(tarifaParaEditar.tipo_movil || "");
      setCapabilityValue(tarifaParaEditar.capability_value || "");
      setTagRate(tarifaParaEditar.tag_rate || "");
      setMinRate(tarifaParaEditar.min_rate || "");
      setKmRate(tarifaParaEditar.km_rate || "");
      setBandera(tarifaParaEditar.bandera || "");
      setEstado(tarifaParaEditar.estado !== undefined ? tarifaParaEditar.estado : 1);
    } else {
      setTipoMovil("");
      setCapabilityValue("");
      setTagRate("");
      setMinRate("");
      setKmRate("");
      setBandera("");
      setEstado(1);
    }
    setError(null);
    setExito(false);
    setMostrarConfirmacion(false);
    setEliminando(false);
    setEliminadoOk(false);
  }, [tarifaParaEditar, visible]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setCargando(true);
    setError(null);
    setExito(false);
    const username = Cookies.get("userName");

    try {
      const endpoint = tarifaParaEditar ? API_ENDPOINTS.interna.UpdateDataTarifa : API_ENDPOINTS.interna.InsertDataTarifa;

      const bodyData = {
        tipo_movil,
        capability_value,
        tag_rate,
        min_rate,
        km_rate,
        bandera,
        estado,
        username,
      };

      if (tarifaParaEditar) {
        bodyData.id = tarifaParaEditar.id;
      }

      const res = await fetch(endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(bodyData),
      });

      const result = await res.json();
      if (!res.ok || result.error) throw new Error(result.error || "Error al guardar tarifa");

      setExito(true);
      setTimeout(() => {
        setExito(false);
        onSuccess?.();
        onClose();
      }, 2000);
    } catch (err) {
      setError(err.message || "Error al guardar tarifa");
    } finally {
      setCargando(false);
    }
  };

  const handleEliminarTarifa = async () => {
    setEliminando(true);
    const username = Cookies.get("userName");

    try {
      const res = await fetch(API_ENDPOINTS.interna.DeleteDataTarifa, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: tarifaParaEditar.id,
          username,
        }),
      });

      const result = await res.json();
      if (!res.ok || result.error) throw new Error(result.error || "Error al eliminar tarifa");

      setEliminadoOk(true);
      setTimeout(() => {
        setEliminadoOk(false);
        onSuccess?.();
        onClose();
      }, 2000);
    } catch (err) {
      setError(err.message || "Error al eliminar tarifa");
    } finally {
      setEliminando(false);
      setMostrarConfirmacion(false);
    }
  };

  if (!visible) return null;

  return (
    <>
      {/* Modal principal */}
      <div className="modal fade show d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content shadow-lg">
            <div className="modal-header">
              <h5 className="modal-title">{tarifaParaEditar ? "Editar Tarifa" : "Agregar Tarifa"}</h5>
              <button type="button" className="btn-close" onClick={onClose} disabled={cargando || exito}></button>
            </div>
            <form onSubmit={handleSubmit}>
              <div className="modal-body position-relative">
                {error && <div className="alert alert-danger">{error}</div>}
                {exito && <div className="alert alert-success text-center position-absolute top-50 start-50 translate-middle w-75 shadow">✅ Tarifa {tarifaParaEditar ? "actualizada" : "insertada"} correctamente.</div>}
                {eliminadoOk && <div className="alert alert-success text-center position-absolute top-50 start-50 translate-middle w-75 shadow">🗑️ Tarifa eliminada correctamente.</div>}
                <fieldset disabled={cargando || exito || eliminadoOk}>
                  <div className="mb-3">
                    <label className="form-label">Tipo Móvil</label>
                    <input type="text" className="form-control" value={tipo_movil} onChange={(e) => setTipoMovil(e.target.value)} required />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Capacidad</label>
                    <input type="text" className="form-control" value={capability_value} onChange={(e) => setCapabilityValue(e.target.value)} />
                  </div>
                  <div className="row">
                    <div className="col">
                      <label className="form-label">TAG</label>
                      <input type="text" className="form-control" value={tag_rate} onChange={(e) => setTagRate(e.target.value)} required min={0} />
                    </div>
                    <div className="col">
                      <label className="form-label">Minuto</label>
                      <input type="number" className="form-control" value={min_rate} onChange={(e) => setMinRate(e.target.value)} required min={0} />
                    </div>
                    <div className="col">
                      <label className="form-label">Kilometro</label>
                      <input type="number" className="form-control" value={km_rate} onChange={(e) => setKmRate(e.target.value)} required min={0} />
                    </div>
                    <div className="col">
                      <label className="form-label">Bajada Bandera</label>
                      <input type="number" className="form-control" value={bandera} onChange={(e) => setBandera(e.target.value)} required min={0} />
                    </div>
                  </div>
                  <div className="mb-3 mt-3">
                    <label className="form-label">Estado</label>
                    <select className="form-select" value={estado} onChange={(e) => setEstado(parseInt(e.target.value))}>
                      <option value={1}>Activo</option>
                      <option value={0}>Inactivo</option>
                    </select>
                  </div>
                </fieldset>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-pill btn-secondary" onClick={onClose} disabled={cargando || exito || eliminadoOk}>
                  Cancelar
                </button>
                {tarifaParaEditar && (
                  <button type="button" className="btn btn-pill btn-outline-danger" onClick={() => setMostrarConfirmacion(true)} disabled={cargando || eliminando || eliminadoOk}>
                    {eliminando ? "Eliminando..." : "Eliminar"}
                  </button>
                )}
                <button type="submit" className="btn btn-pill btn-primary" disabled={cargando || exito || eliminadoOk}>
                  {cargando ? "Guardando..." : "Guardar"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* Modal de confirmación para eliminar */}
      {mostrarConfirmacion && (
        <div className="modal fade show d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content shadow">
              <div className="modal-header bg-danger text-white">
                <h5 className="modal-title">Confirmar eliminación</h5>
              </div>
              <div className="modal-body">
                <p>¿Estás seguro de que deseas eliminar esta tarifa?</p>
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setMostrarConfirmacion(false)} disabled={eliminando}>
                  Cancelar
                </button>
                <button className="btn btn-danger" onClick={handleEliminarTarifa} disabled={eliminando}>
                  {eliminando ? "Eliminando..." : "Eliminar"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default TarifasFormModal;
